<template>
  <div class="pcBox">
    <div class="pcBox-header">
      <div class="clearfix">
        <div class="div_left">
          <span class="logo"></span>
          <span style="margin-left: 10px">{{ $t("common.title") }}</span>
        </div>
        <!-- <div class="div_right" @click="changeL(languageTitle)">
          <span class="lgIcon"></span>
          <span style="margin-left: 6px;">{{ languageTitle }}</span>
        </div> -->
        <!-- 切换语言 -->
        <div class="div_select_right">
          <el-select
            v-model="languagekey"
            placeholder="Select"
            size="large"
            style="width: 240px"
            @change="changeL(languagekey)"
          >
            <el-option
              v-for="item in language"
              :key="item.text"
              :label="item.text"
              :value="item.value"
            />
          </el-select>
          <div
            class="div_close_button"
            @click="showCloseDialog"
            v-if="Boolean(showReturnButton)"
          >
            <span class="close-icon">✕</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pcBox-center">
      <div class="topStatus">
        <div class="top clearfix">
          <div class="div_left" style="display: flex;">
            <span class="statusIcon">
              <img
                v-if="successStatus || waitStatus"
                width="24"
                src="../../assets/pc/hook_blue@2x.png"
                alt
              />
              <img
                v-if="overtimeStatus || failStatus"
                src="../../assets/pc/fork_red.svg"
                alt
              />
            </span>
            <span class="statusText" v-if="successStatus">
              {{ $t("pc.successStatusInfo") }}
            </span>
            <span class="statusText" v-if="overtimeStatus">
              {{ $t("pc.overtimeStatusInfo") }}
            </span>
            <span class="statusText" v-if="waitStatus">
              {{ $t("pc.waitStatusInfo") }}
            </span>
            <span class="statusText" v-if="failStatus">
              {{ $t("pc.failStatusInfo") }}
            </span>
          </div>
          <div class="div_right">
            <span
              style="font-size:16px;color:rgba(102,102,102,1);"
              v-if="successStatus"
            >
              {{ $t("pc.payTotel1") }}
            </span>
            <span
              style="font-size:16px;color:rgba(102,102,102,1);"
              v-if="waitStatus || overtimeStatus"
            >
              {{ $t("pc.payTotel") }}
            </span>
            <span
              style="font-size:24px;line-height:24px;font-weight:600;color:rgba(255,121,40,1);margin-left:16px"
            >
              <span style="font-size: 16px;margin-top: -3px;">
                {{ goodInfo.currencySymbol }}
              </span>
              {{ goodInfo.totalFee }}
            </span>
          </div>
        </div>
        <div class="timeBox" v-if="timeInfoFlag && waitStatus">
          {{ $t("pc.leftTime") }}
          <span>{{ countDownList }}</span>
          {{ $t("pc.rightTime") }}
        </div>
      </div>
      <div class="botGoods">
        <div class="part clearfix">
          <span
            class="leftTitle div_left"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:165px'
                : this.$i18n.locale === 'fr'
                ? 'width: 180px'
                : this.$i18n.locale === 'ko'
                ? 'width: 100px'
                : 'width: 80px'
            "
          >
            {{ $t("pc.goodsNo") }}
          </span>
          <span
            class="rightInfo div_right"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:885px'
                : this.$i18n.locale === 'fr'
                ? 'width: 870px'
                : this.$i18n.locale === 'ko'
                ? 'width: 960px'
                : 'width: 980px'
            "
          >
            {{ goodInfo.merchantOrderNoClear }}
          </span>
        </div>
        <div class="part clearfix">
          <span
            class="leftTitle div_left"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:165px'
                : this.$i18n.locale === 'fr'
                ? 'width: 180px'
                : this.$i18n.locale === 'ko'
                ? 'width: 100px'
                : 'width: 80px'
            "
          >
            {{ $t("pc.goodsName") }}
          </span>
          <span
            class="rightInfo div_right"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:885px'
                : this.$i18n.locale === 'fr'
                ? 'width: 870px'
                : this.$i18n.locale === 'ko'
                ? 'width: 960px'
                : 'width: 980px'
            "
          >
            {{ goodInfo.goodsName }}
          </span>
        </div>
        <div class="part clearfix" style="margin-bottom: 0">
          <span
            class="leftTitle div_left"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:165px'
                : this.$i18n.locale === 'fr'
                ? 'width: 180px'
                : this.$i18n.locale === 'ko'
                ? 'width: 100px'
                : 'width: 80px'
            "
          >
            {{ $t("pc.goodsDes") }}
          </span>
          <span
            class="rightInfo div_right"
            :style="
              this.$i18n.locale === 'en'
                ? 'width:885px'
                : this.$i18n.locale === 'fr'
                ? 'width: 870px'
                : this.$i18n.locale === 'ko'
                ? 'width: 960px'
                : 'width: 980px'
            "
          >
            {{ goodInfo.goodsDetail }}
          </span>
        </div>
      </div>
    </div>
    <div
      class="pcBox-footer"
      v-if="overtimeStatus || successStatus || failStatus"
    >
      <div class="resultIcon">
        <img
          v-if="successStatus"
          src="../../assets/pc/payment_success_pc.png"
          width="140"
          alt
        />
        <img
          v-if="failStatus"
          src="../../assets/pc/payment_failure_pc.png"
          width="140"
          alt
        />
        <img
          v-if="overtimeStatus"
          src="../../assets/pc/order_invalid_pc.png"
          width="140"
          alt
        />
      </div>
      <div class="resultText" v-if="successStatus">
        {{ $t("pc.successText1") }}
        <span @click="backRrturnUrl" style="text-decoration:underline">
          {{ $t("pc.successText2") }}
        </span>
      </div>
      <div class="resultText" v-if="overtimeStatus">
        {{ $t("pc.overtimeText1") }}
        <span @click="backRrturnUrl" style="text-decoration:underline">
          {{ $t("pc.overtimeText2") }}
        </span>
        {{ $t("pc.overtimeText3") }}
      </div>
      <div class="resultText" v-if="failStatus">
        {{ $t("pc.failText1") }}
        <span @click="failBackRrturnUrl" style="text-decoration:underline">
          {{ $t("pc.failText2") }}
        </span>
        {{ $t("pc.failText3") }}
      </div>
    </div>
    <div class="pcBox-footer" v-else>
      <div class="title">{{ $t("pc.payWaysTitle") }}</div>
      <div class="payWays">
        <div v-for="(item, index) in goodInfo.payWayConfigList" :key="index">
          <!-- 判断如果payWayName是applepay且supportsApplePay为ture或者 判断如果payWayName是googlepay或者isGooglePaySupported为true或者不含有googlepay或者ApplePay-->
          <div
            v-if="
              (item.payWayCode == 9 && supportsApplePay()) ||
                item.payWayCode != 9
            "
            class="part hoverPart clearfix"
            :key="item.payWayName"
            :style="
              checkoutValue == item.curPayProductData.productCode
                ? 'border:1px solid #FFAA0A;background:#fff'
                : 'border:1px solid rgba(204,204,204,1);background:#fff'
            "
            @click="
              selectPay(item.curPayProductData.productCode, item.payWayCode)
            "
          >
            <span class="payIcon div_left">
              <img :src="item.logoUrl" alt />
            </span>
            <span class="payPro">
              <van-cell
                v-if="item.curPayProductData.productCode !== 31"
                center
                :value="item.payWayName"
              />
              <van-cell
                v-else-if="item.curPayProductData.productCode == 31"
                :title="item.payWayName"
                label="请使用手机打开微信扫一扫，完成扫码付款。"
              ></van-cell>
            </span>
          </div>
          <!-- 如果是选中FPX支付 -->
          <div
            v-if="
              item.curPayProductData.productCode == 46 && checkoutValue == 46
            "
          >
            <p class="mol_tip">选择您的银行</p>
            <div id="molpay_ebanking_fpx_MY-container"></div>
          </div>
        </div>
        <div class="payBtn-group ">
          <!-- 授权协议选择 -->
          <div class="agreement-group">
            <van-checkbox
              v-model="isAgree"
              v-if="achAgreement"
              @change="handleAgreement"
              shape="square"
              color="#ffaa0a"
            >
            </van-checkbox>
            <div class="agreement-text" v-if="achAgreement">
              <!-- <span>我已阅读并同意</span> -->
              <agreement-popup
                @agreement-confirmed="handleAgreementConfirmed"
                :position="position"
                :amount="goodInfo.totalFee"
                @popup-closed="handlePopupClosed"
              />
            </div>
          </div>
          <div class="payBtn" @click="goPay" id="">{{ $t("pc.payBtn") }}</div>

        </div>

        <!-- <div class="googleOrApplePayButton" id="googleOrApplePayButton"></div> -->
      </div>
    </div>
    <!-- loading盒子 -->
    <div class="loadingBox" v-if="loadingFlag">
      <div class="bg"></div>
      <div class="centerBox">
        <img src="../../assets/pc/loading.gif" alt />
        <div>{{ $t("common.loadingCommonText") }}</div>
      </div>
    </div>
    <div class="payResultBox" v-if="payResult">
      <div class="bg"></div>
      <div class="payResultCenterBox">
        <div class="title clearfix">
          <div class="div_left">
            <img :src="logoInfo.path" alt />
            {{ logoInfo.name }}
          </div>
          <div class="div_right" @click="closePayResult">
            <span></span>
          </div>
        </div>
        <div class="centerContent">
          <!-- 其它 -->
          <qrcode
            class="qrcode"
            :value="qrcodeUrl"
            :options="{ size: 300 }"
            v-if="qrcodeType === 'QRCODE_NORMAL'"
            >{{ qrcodeUrl }}</qrcode
          >
          <!-- paynow支付 -->
          <div v-else ref="qrcodeRef" style="text-align: center;"></div>
          <div class="botText" style="margin-top:14px;">
            <template v-if="qrcodeType === 'QRCODE_NORMAL'">
              {{ $t("pc.scanCodePart1") }}
              <span>{{ logoInfo.name }}</span>
              {{ $t("pc.scanCodePart2") }}
            </template>
            <!--支付宝香港-->
            <template v-else-if="qrcodeType === 'QRCODE_ALI_HK'">
              <iframe
                :src="qrcodeUrl"
                frameborder="0"
                width="300"
                height="300"
                class="ali-hk-frame"
              ></iframe>
              <div style="margin-top:14px">
                {{ $t("pc.aliHKScanCodePart1") }}
                <span>{{ $t("pc.aliHKScanCodeApp") }}</span>
                {{ languageTitle == "English" ? $t("pc.aliHKPay") : "" }}
              </div>
            </template>
            <!-- paynow -->
            <template v-else>
              {{ $t("pc.paynowScanCodeNormal1") }}
              <span>{{ $t("pc.paynowScanCodeApp") }}</span>
              {{
                languageTitle == "English" ? $t("pc.paynowScanCodeNormal2") : ""
              }}
            </template>
          </div>
          <div class="botText">
            {{ qrcodeType === "QRCODE_NORMAL" ? $t("pc.scanCodePart3") : "" }}
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="googleOApplePayShow"
      get-container="body"
      closeable
      close-icon="close"
      position="center"
      :style="{ height: '200px', width: '320px', borderRadius: '10px' }"
    >
      <div class="googleOrApplePayButton-wrap">
        <p class="tips">请点击按钮支付</p>
        <img
          class="loading-img"
          v-if="loading"
          src="../../assets/pc/tal_button_loading_black.png"
          alt
        />
        <div class="googleOrApplePayButton" id="googleOrApplePayButton"></div>
      </div>
    </van-popup>
    <!-- stripe express checkout -->

    <van-popup
      v-model="stripeExpressCheckoutPopupShow"
      get-container="body"
      closeable
      close-icon="close"
      position="center"
      :style="{ height: '200px', width: '320px', borderRadius: '10px' }"
    >
      <div class="stripeExpressCheckoutButton-wrap">
        <p class="tips">请点击按钮支付</p>
        <img
          class="loading-img"
          v-if="loading"
          src="../../assets/pc/tal_button_loading_black.png"
          alt
        />
        <div class="stripeExpressCheckoutButton" id="stripeExpressCheckoutButton"></div>
      </div>
    </van-popup>
    <!-- Airwallex卡支付 -->
    <airwallex-payment
      v-model="airwallexPopupShow"
      :responseData="airwallexResponseData"
      :client-secret="clientSecret"
      :amount="goodInfo.totalFee"
      :currency="goodInfo.currency"
      :environment="goodInfo.airwallexEnv === 'LIVE' ? 'prod' : 'demo'"
      :is-mobile="false"
      @payment-success="handleAirwallexSuccess"
      @payment-error="handleAirwallexError"
      @initialized="handleAirwallexInitialized"
      @report-log="reportLog"
    />
    <!-- ach支付AchPaymentCardList -->
    <pcAchPayment
      v-if="showAchPayment"
      :cardList="cardList"
      :showPopup="showAchPayment"
      :environment="environment"
      :clientKey="clientKey"
      :initialSelectedCardId="initialSelectedCardId"
      :showAchPayment="showAchPayment"
      @goPay="goPay"
      @delete-card="deleteCard"
      @card-selected="cardSelected"
      @close-popup="closeAchPayment"
      @payment-completed="handlePaymentCompleted"
      @payment-error="handlePaymentError"
      @payment-submit="handlePaymentSubmit"
      @payment-change="handlePaymentChange"
    />
  </div>
</template>
<script>
import "@/style/pc/reset.css";
import utils from "@/utils/index";
import api from "@/api/api";
import Qrcode from "@xkeshi/vue-qrcode";
import { Base64 } from "js-base64";
import { Notify, Toast } from "vant";
import indexMixin from "../../mixins/index";

import * as QRCode from "easyqrcodejs";
import pcAchPayment from "@/components/pcAchPayment.vue";
// import { createElement, loadAirwallex, getElement, confirmPaymentIntent } from 'airwallex-payment-elements';
import AgreementPopup from "@/components/AgreementPopup.vue";
import AirwallexPayment from "@/components/AirwallexPayment.vue";
const CMB_PAY_URL =
  location.host.indexOf("checkout") === 0
    ? "https://netpay.cmbchina.com/netpayment/BaseHttp.dll?PC_EUserPay"
    : "http://121.15.180.66:801/netpayment/BaseHttp.dll?PC_EUserPay";
export default {
  components: {
    qrcode: Qrcode,
    AgreementPopup,
    pcAchPayment,
    AirwallexPayment
  },
  mixins: [indexMixin],
  data() {
    return {
      payProductPcList: [
        46,
        5,
        3,
        39,
        41,
        11,
        44,
        26,
        12,
        30,
        31,
        18,
        19,
        21,
        29,
        25,
        51,
        49,
        60,
        61,
        63,
        71,
        74,
        77,
        80
      ],
      language: [
        { text: "English", value: "0" },
        { text: "简体中文", value: "1" },
        { text: "Français", value: "2" },
        { text: "日本語", value: "3" },
        { text: "한국어", value: "4" }
      ],
      languageTitle: "English",
      languagekey: "0",
      goodInfo: {},
      queryStatus: null,
      timeInfoFlag: false,
      countDownList: "00:00:00",
      checkoutValue: "",
      qrcodeUrl: "",
      successStatus: false,
      overtimeStatus: false,
      waitStatus: false,
      failStatus: false,
      loadingFlag: false,
      loading: false,
      payResult: false,
      logoInfo: {
        path: "",
        name: ""
      },
      qrcodeType: "",
      paynowImg: require("../../assets/pc/paynowLogo.png"),
      placeholder: this.$t("moblie.popupTitle"),
      fpxType: "",
      fpxName: "",
      issuers: [],
      onlineBankingMalaysiaComponent: null,
      fpxPaymentMethod: null,
      highlightedIssuers: [],
      clientKey: "",
      environment: "",
      countryCode: "",
      clientSecret: "",
      googleOApplePayShow: false,
      payTradeNo: "",
      isAgree: true,
      position: "center",
      showAchPayment: false,
      achAgreement: false,
      initialSelectedCardId: null,
      bankAccountListToken: "",
      cardList: [],
      isFormValid: true,
      extendParam: "",
      // 保存上次的协议勾选状态，用于弹窗关闭时的状态恢复
      lastAgreementState: true,
      // 标记是否是程序手动修改isAgree值，而不是用户点击
      isProgrammaticChange: false,
      bankAccountToken: null,
      airwallexPopupShow: false,
      airwallexResponseData: {},
      cardElement: null,
      cardNumber: null,
      expiry: null,
      cvc: null,
      domElement: null,
      showReturnButton: 0,
      cancelUrl: "",
      stripeExpressCheckoutPopupShow: false,
      stripePublishableKey: "",
      merchantName: "",
      amount: 0,
      currency: "",
      stripeEnv: ""
    };
  },
  methods: {
    /**
     * @method sanitizeAndValidateUrl
     * @description 清理和验证URL，处理各种可能的URL格式问题
     * @param {String} url 原始URL
     * @returns {String|null} 处理后的有效URL，如果无法修复则返回null
     */
    sanitizeAndValidateUrl(url) {
      if (!url || typeof url !== "string") {
        return null;
      }

      let processedUrl = url.trim();

      try {
        // 处理多重URL编码
        let decodedUrl = processedUrl;
        let maxDecodeAttempts = 3; // 最多尝试解码3次，防止无限循环

        for (let i = 0; i < maxDecodeAttempts; i++) {
          try {
            const decoded = decodeURIComponent(decodedUrl);
            if (decoded === decodedUrl) {
              break; // 如果解码后没有变化，说明已经完全解码
            }
            decodedUrl = decoded;
          } catch (e) {
            break; // 解码失败，使用当前结果
          }
        }

        processedUrl = decodedUrl;

        // 添加协议前缀（如果缺失）
        if (!/^https?:\/\//i.test(processedUrl)) {
          processedUrl = "https://" + processedUrl;
        } else if (processedUrl.startsWith("http://")) {
          processedUrl = processedUrl.replace("http://", "https://");
        }

        // 使用原生URL构造函数验证URL格式
        const urlObj = new URL(processedUrl);

        // 基本安全检查
        const hostname = urlObj.hostname.toLowerCase();

        // 检查是否为有效的域名格式
        const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (!domainRegex.test(hostname)) {
          console.warn("Invalid domain format:", hostname);
          return null;
        }

        // 防止一些常见的恶意URL
        const blockedPatterns = [
          /^javascript:/i,
          /^data:/i,
          /^vbscript:/i,
          /^file:/i
        ];

        for (const pattern of blockedPatterns) {
          if (pattern.test(processedUrl)) {
            console.warn("Blocked potentially dangerous URL:", processedUrl);
            return null;
          }
        }

        return urlObj.toString();
      } catch (error) {
        console.warn(
          "URL validation failed:",
          error.message,
          "for URL:",
          processedUrl
        );
        return null;
      }
    },
    /**
     * @method showCloseDialog
     * @description 点击关闭按钮，跳转到 cancelUrl
     */
    showCloseDialog() {
      if (this.cancelUrl) {
        // 跳转到业务方传入的 cancelUrl
        const sanitizedUrl = this.sanitizeAndValidateUrl(this.cancelUrl);

        if (sanitizedUrl) {
          try {
            // 使用 window.open 在当前窗口跳转
            window.open(sanitizedUrl, "_self");
          } catch (error) {
            console.error("Failed to navigate to URL:", error);
            Notify({
              type: "danger",
              message: "跳转失败，URL格式错误"
            });
          }
        } else {
          // URL验证失败
          console.error("Invalid cancelUrl:", this.cancelUrl);
          Notify({
            type: "danger",
            message: "跳转失败，URL格式不正确"
          });
        }
      } else {
        // 如果没有 cancelUrl，则执行默认的返回操作
        Notify({
          type: "danger",
          message: "跳转失败，请稍后重试"
        });
      }
    },
    /**
     * @method airwallexInitSelect a payment method

     * @param {String} airwallex支付
     * @param {String} params 支付参数
     * @description 卡支付
     */
    // initializeAirwallex() {
    //   loadAirwallex({
    //     env: 'demo', // Can choose other production environments, 'staging | 'demo' | 'prod'
    //     origin: window.location.origin, // Setup your event target to receive the browser events message
    //   }).then(() => {
    //     this.cardNumber = createElement("cardNumber");
    //     this.expiry = createElement("expiry");
    //     this.cvc = createElement("cvc");
    //     this.domElement = this.cardNumber.mount("cardNumber");
    //     this.expiry.mount("expiry");
    //     this.cvc.mount("cvc");
    //   });
    // },

    /**
     * @method AdyenCheckoutInit
     * @param {string} title adyen配置
     * @description fpx支付
     */
    async AdyenCheckoutInit() {
      let _this = this;
      // 初始化adyencheckout
      let paymentMethodsArray = [];
      paymentMethodsArray.push({
        type: this.fpxType,
        name: this.fpxName,
        issuers: this.issuers
      });
      const configuration = {
        paymentMethodsResponse: {
          paymentMethods: paymentMethodsArray
        },
        analytics: {
          enabled: true // Set to false to not send analytics data to Adyen.
        },
        showPayButton: false,
        environment: _this.environment, // Change to 'live' for the live environment.
        clientKey: _this.clientKey, //live_T536KAE6W5BTLPEQPFBAHMZZL4DHNHW4 Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        onPaymentCompleted: (result, component) => {
          console.log(result, component, "onPaymentCompleted");
        },
        onChange: (state, component) => {
          console.log(state, component, "onChange");
        },
        onSubmit: (state, component) => {
          console.log(state, component, "onsubmit");
          _this.fpxPaymentMethod = state.data.paymentMethod;
          // onlineBankingMalaysiaComponent.handleAction(state.data.paymentMethod);
        },
        onError: (error, component) => {
          console.error(error, component, "onError");
        }
      };
      // Move the declaration outside the block scope
      const onlineBankingMalaysiaConfiguration = {
        showImage: true, // Optional. Set to **false** to remove the bank logos from the Online banking Malaysia form.
        placeholder: this.placeholder // Optional. Set to **null** to remove the placeholder text from the bank selection dialog.
        // highlightedIssuers: this.highlightedIssuers // Optional. List of bank codes to highlight in the bank selection dialog.
      };
      const checkout = await new window.AdyenCheckout(configuration);
      _this.onlineBankingMalaysiaComponent = checkout
        .create("molpay_ebanking_fpx_MY", onlineBankingMalaysiaConfiguration)
        .mount("#molpay_ebanking_fpx_MY-container");
    },
    /**
     * @method changeL
     * @param {string} title 语种
     * @description 语言切换
     */
    changeL(title) {
      const languages = {
        "0": { locale: "en", title: "English" },
        "1": { locale: "zh", title: "简体中文" },
        "2": { locale: "fr", title: "Français" },
        "3": { locale: "ja", title: "日本語" },
        "4": { locale: "ko", title: "한국어" }
      };
      const selectedLanguage = languages[title];
      if (selectedLanguage) {
        this.$i18n.locale = selectedLanguage.locale;
        this.languageTitle = selectedLanguage.title;
        localStorage.setItem("lang", selectedLanguage.locale);
      }
    },
    /**
     * @methods setGoodInfo
     * @description 获取页面信息
     */
    setGoodInfo() {
      let merchantPayNo = utils.getUrlSearch("merchantPayNo");
      let businessCode = utils.getUrlSearch("businessCode");
      let checkoutToken = utils.getUrlSearch("checkoutToken");
      this.showReturnButton =
        parseFloat(utils.getUrlSearch("showReturnButton")) || 0;
      this.cancelUrl = utils.getUrlSearch("cancelUrl") || "";
      this.loadingFlag = true;

      api.apiMethod.checkoutShow
        .post(
          {
            merchantPayNo: merchantPayNo,
            businessCode: businessCode,
            checkoutType: 1
          },
          {
            checkoutToken: checkoutToken
          }
        )
        .then(res => {
          this.loadingFlag = false;
          console.log(res.data);
          if (res.data.code === 10000) {
            res.data.data.payWayConfigList =
              this.payWayConfigList(
                res.data.data.payWayConfigList,
                this.payProductPcList
              ) || [];
            console.log(
              res.data.data.payWayConfigList,
              "res.data.data.payWayConfigList"
            );
            this.goodInfo = res.data.data;
            console.log(this.goodInfo, "this.goodInfo");
            // 初始化支付产品
            if (this.goodInfo.payWayConfigList) {
              this.goodInfo.payWayConfigList.map(item => {
                // if (item.checked && item.platformType === 1) {
                //   this.checkoutValue = item.curPayProductData.productCode;
                // }
                // 如果是fpx支付，payProduct=46
                if (item.curPayProductData.productCode === 46) {
                  this.issuers = item.curPayProductData.issuers;
                  this.fpxType = item.curPayProductData.type;
                  this.fpxName = item.name;
                  this.clientKey = item.curPayProductData.adyenClientKey;
                  // 将clientKeyy以'_''分割,取第一个值为environment
                  this.environment = item.curPayProductData.adyenClientKey.split(
                    "_"
                  )[0];
                  // console.log(this.environment, 'this.environment')
                }
                // 如果是ach支付，payProduct=61
                if (item.curPayProductData.productCode === 61) {
                  this.bankAccountListToken =
                    item.curPayProductData.bankAccountListToken;
                  // 如果没有选择已阅读协议，则提示
                  if (!this.isAgree) {
                    Notify({ type: "warning", message: "请先阅读并同意协议" });
                    return false;
                  }
                  this.environment = item.curPayProductData.adyenClientKey.split(
                    "_"
                  )[0];
                  this.clientKey = item.curPayProductData.adyenClientKey;
                }
              });
            }
            if (res.data.data.status === 1) {
              // 当初始化时订单状态为完成则直接跳转到订单成功页面
              this.payStatusResult(1);
            } else if (res.data.data.status === 2) {
              this.payStatusResult(2);
            } else if (res.data.data.status === 3) {
              this.payStatusResult(3);
            } else {
              // 判断订单是否超时
              let nowTime =
                Math.abs(new Date().getTime() - this.goodInfo.nowTime) > 3000
                  ? this.goodInfo.nowTime
                  : new Date().getTime();
              if (this.goodInfo.specificTimeout) {
                this.timeInfoFlag = true;
                if (this.goodInfo.specificTimeout - nowTime > 0) {
                  // 未超时
                  this.waitStatus = true;
                  this.successStatus = false;
                  this.overtimeStatus = false;
                  this.failStatus = false;
                  this.countDown(
                    this.goodInfo.nowTime,
                    this.goodInfo.specificTimeout
                  );
                } else {
                  // 订单超时
                  this.payStatusResult(3);
                }
              } else {
                this.waitStatus = true;
                this.successStatus = false;
                this.overtimeStatus = false;
                this.failStatus = false;
              }
            }
            this.reportLog({
              eventId: "CONFIGSUCCESS_PC",
              msg: ""
            });
          } else {
            this.reportLog({
              eventId: "CONFIGFAIL_PC",
              msg: ""
            });
            Notify({ type: "warning", message: res.data.subMsg });
          }
        });
    },
    /**
     * @method payStatusResult
     * @param {String} status
     * @description 根据支付状态改变结果
     */
    payStatusResult(status) {
      this.payResult = false;
      if (status === 1) {
        // 成功
        this.successStatus = true;
        this.overtimeStatus = false;
        this.waitStatus = false;
        this.failStatus = false;
      } else {
        if (status === 2) {
          // 失败
          this.successStatus = false;
          this.overtimeStatus = false;
          this.waitStatus = false;
          this.failStatus = true;
        } else if (status === 3) {
          // 超时
          this.successStatus = false;
          this.overtimeStatus = true;
          this.waitStatus = false;
          this.failStatus = false;
          // 如果ach支付，则关闭ach支付弹窗
          if (this.checkoutValue === 61) {
            this.closeAchPayment();
          }
        }
      }
    },
    /**
     * @method goPay
     * @description 点击支付
     */
    goPay(payType) {
      this.reportLog({
        eventId: "CONFIRMPAYMENT_PC",
        msg: this.checkoutValue
      });

      // 如果支付方式为fpxH5
      if (this.checkoutValue === 46) {
        this.onlineBankingMalaysiaComponent.submit();
        // 如果没有选中银行卡
        if (!this.fpxPaymentMethod) {
          Notify({ type: "warning", message: this.$t("common.payMethods") });
          return false;
        }
        // 删掉不需要的字段
        delete this.fpxPaymentMethod.checkoutAttemptId;
        this.extendParam = JSON.stringify(this.fpxPaymentMethod);
      }
      // 如果是ach支付
      if (
        this.checkoutValue === 61 &&
        (!payType ||
          (payType.type !== "cardPayment" && payType.type !== "newCardPayment"))
      ) {
        // 如果勾选了协议，则展示ach支付
        if (this.isAgree) {
          this.showAchPayment = true;
          this.fetchCardList();
          return false;
        } else {
          Notify({ type: "warning", message: "请先阅读并同意协议" });
          return false;
        }
      }

      // 处理卡片支付
      if (payType && payType.type === "cardPayment") {
        this.bankAccountToken = payType.bankAccountToken;
        // 设置支付参数
        this.extendParam = JSON.stringify({
          bankAccountToken: this.bankAccountToken
        });
      }

      // 用payWayCode匹配出payWayName
      this.goodInfo.payWayConfigList.map(item => {
        if (item.curPayProductData.productCode === this.checkoutValue) {
          this.payWayCode = item.payWayCode;
          this.payWayName = item.payWayName;
          this.stripePublishableKey = item.curPayProductData
            .stripePublishableKey
            ? item.curPayProductData.stripePublishableKey
            : "";
          this.stripeEnv = item.curPayProductData.env
            ? item.curPayProductData.env
            : "";
          this.merchantName = item.merchantName || "";
          this.countryCode = item.curPayProductData.countryCode || "";
        }
      });

      let checkoutToken = utils.getUrlSearch("checkoutToken");
      let params = {
        checkoutType: 1,
        businessCode: this.goodInfo.businessCode,
        payProduct: this.checkoutValue,
        payWayCode: this.payWayCode,
        payWayName: this.payWayName,
        merchantPayNo: utils.getUrlSearch("merchantPayNo"),
        extendParam: this.extendParam // string格式
      };

      if (!this.checkoutValue) {
        Notify({ type: "warning", message: this.$t("common.payMethods") });
      } else {
        this.loadingFlag = true;
        api.apiMethod.goPay
          .post(params, {
            checkoutToken: checkoutToken,
            osType: utils.getOsType()
          })
          .then(res => {
            this.loadingFlag = false;
            console.log(res.data);
            if (res.data.code === 10000) {
              // 处理成功响应
              this.reportLog({
                eventId: "PAYSUCCESS_PC",
                payCode: this.checkoutValue
              });
              // 开启轮询
              this.queryOrder();
              // 支付宝支付
              let itUrl = location.host;
              switch (this.checkoutValue) {
                case 5: {
                  let url = `https://${itUrl}/wxblank?merchantPayNo=${utils.getUrlSearch(
                    "merchantPayNo"
                  )}&payOrderNo=${utils.getUrlSearch(
                    "payOrderNo"
                  )}&payProduct=5&businessCode=${
                    this.goodInfo.businessCode
                  }&checkoutToken=${checkoutToken}`;
                  this.qrcodeUrl = url;
                  this.qrcodeType = "QRCODE_NORMAL";
                  this.payResult = true;
                  this.logoInfo.path = res.data.data.logoUrl;
                  this.logoInfo.name = res.data.data.payProductName;
                  this.queryOrder();
                  break;
                }
                case 60: {
                  this.qrcodeUrl = JSON.parse(
                    JSON.parse(res.data.data.url).nextAction
                  ).qrcode_url;
                  console.log(this.qrcodeUrl, "=====this.qrcodeUrl");
                  this.qrcodeType = "QRCODE_NORMAL";
                  this.payResult = true;
                  this.logoInfo.path = res.data.data.logoUrl;
                  this.logoInfo.name = res.data.data.payProductName;
                  this.queryOrder();
                  break;
                }
                case 3: {
                  let url = `https://${itUrl}/wxblank?merchantPayNo=${utils.getUrlSearch(
                    "merchantPayNo"
                  )}&payOrderNo=${utils.getUrlSearch(
                    "payOrderNo"
                  )}&payProduct=3&businessCode=${
                    this.goodInfo.businessCode
                  }&checkoutToken=${checkoutToken}`;
                  this.qrcodeUrl = url;
                  this.qrcodeType = "QRCODE_NORMAL";
                  this.payResult = true;
                  this.logoInfo.path = res.data.data.logoUrl;
                  this.logoInfo.name = res.data.data.payProductName;
                  this.queryOrder();
                  break;
                }
                case 71:
                case 74: {
                  this.loadingFlag = true;
                  let url = JSON.parse(JSON.parse(res.data.data.url).nextAction)
                    .url;
                  window.location.href = url;
                  this.queryOrder();
                  break;
                }
                case 39:
                case 41:
                case 11:
                case 44:
                case 46:
                case 26: {
                  this.loadingFlag = true;
                  let url = Base64.decode(res.data.data.url);
                  window.location.href = url;
                  console.log("11 Paypal支付  26支付宝国际支付");
                  this.queryOrder();
                  break;
                }
                case 12:
                case 30:
                case 31:
                  if (
                    res.data.data.packageParams &&
                    typeof window.Stripe !== "undefined"
                  ) {
                    this.loadingFlag = true;
                    let packageParams = JSON.parse(res.data.data.packageParams);
                    var stripe = window.Stripe(
                      packageParams.stripePublishableKey
                    );
                    stripe
                      .redirectToCheckout({
                        sessionId: packageParams.stripeSessionId
                      })
                      .then(function(result) {
                        console.log(result);
                      });
                  }
                  break;
                case 18: {
                  let url = Base64.decode(res.data.data.url);
                  this.qrcodeUrl = url;
                  this.qrcodeType = "QRCODE_NORMAL";
                  this.payResult = true;
                  this.logoInfo.path = res.data.data.logoUrl;
                  this.logoInfo.name = res.data.data.payProductName;
                  this.queryOrder();
                  break;
                }
                case 19: {
                  this.$router.push({
                    name: "wxblank",
                    params: {
                      paramsUrl: res.data.data.packageParams
                    }
                  });
                  break;
                }
                case 21:
                  console.log("一网通支付");
                  if (res.data.data.packageParams) {
                    this.postHref(
                      CMB_PAY_URL,
                      Base64.decode(res.data.data.packageParams)
                    );
                  }
                  break;
                case 29:
                  console.log("香港支付宝支付");
                  this.qrcodeType = "QRCODE_ALI_HK";
                  this.qrcodeUrl = Base64.decode(res.data.data.url);
                  this.logoInfo.path = res.data.data.logoUrl;
                  this.logoInfo.name = res.data.data.payProductName;
                  this.payResult = true;
                  this.queryOrder();
                  break;
                case 25:
                  // paynow
                  this.qrcodeType = "QRCODE_PAYNOW";
                  this.payResult = true;
                  this.logoInfo.path = res.data.data.logoUrl;
                  this.logoInfo.name = res.data.data.payProductName;
                  this.queryOrder();
                  // eslint-disable-next-line no-case-declarations
                  let options = {
                    text: res.data.data.packageParams,
                    width: 256,
                    height: 256,
                    colorDark: "#90137B",
                    colorLight: "#FFFFFF",
                    dotScale: 1,
                    quietZone: 12,
                    quietZoneColor: "#FFFFFF",
                    logo: this.paynowImg,
                    logoWidth: 77,
                    logoHeight: 77
                  };
                  this.$nextTick(() => {
                    new QRCode(this.$refs.qrcodeRef, options);
                  });
                  break;
                case 49:
                  this.handlePaymentCase(49, res);
                  break;
                case 51:
                  this.handlePaymentCase(51, res);
                  break;
                case 63:
                  this.handlePaymentCase(63, res);
                  break;
                case 61:
                  // 关闭弹窗
                  // this.closeAchPayment();
                  this.queryOrder();
                  break;
                case 77:
                  // 调起stripe apple pay
                  this.stripeApplePay(77, res, this.stripePublishableKey);
                  break;
                case 80:
                  // 调起stripe google pay
                  this.stripeGooglePay(80, res, this.stripePublishableKey);
                  break;
                default:
                  break;
              }
            } else {
              // 失败
              this.payStatusResult(2);
              // 如果是ach，则关闭弹窗
              if (this.checkoutValue === 61) {
                this.closeAchPayment();
              }
              this.reportLog({
                eventId: "PAYERROR_PC",
                msg: this.checkoutValue
              });
            }
          });
      }
    },
    /**
     * @method closePayResult
     * @description 关闭弹窗
     */
    closePayResult() {
      this.queryStatus && clearInterval(this.queryStatus);
      this.payResult = false;
      this.setGoodInfo();
    },
    /**
     * @method countDown
     * @description 根据服务器返回的超时时间算出倒计时
     */
    timeFormat(param) {
      return param < 10 ? "0" + param : param;
    },
    countDown(nowTime, endTime) {
      let newTime =
        Math.abs(new Date().getTime() - nowTime) > 3000
          ? nowTime
          : new Date().getTime();

      // 定义倒计时逻辑函数
      const updateCountDown = () => {
        // 获取当前时间，同时得到活动结束时间数组
        // 对结束时间进行处理渲染到页面
        let obj = null;
        // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000;
          // 获取天、时、分、秒
          let hou = parseInt(time / 3600);
          let min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          let sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          obj = {
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec)
          };
        } else {
          // 活动已结束，全部设置为'00'
          obj = {
            hou: "00",
            min: "00",
            sec: "00"
          };
          this.countDownList = obj.hou + ":" + obj.min + ":" + obj.sec;
          this.payStatusResult(3);
          clearInterval(interval);
          return false; // 返回 false 表示停止执行
        }
        this.countDownList = obj.hou + ":" + obj.min + ":" + obj.sec;
        newTime = newTime + 1000;
        return true; // 返回 true 表示继续执行
      };
      // 立即执行一次
      if (updateCountDown()) {
        // 如果第一次执行成功（没有到时间），则设置定时器继续执行
        var interval = setInterval(updateCountDown, 1000);
      }
    },
    /**
     * @method queryOrder
     * @description 查询订单状态
     */
    queryOrder() {
      console.log("queryOrder");
      let checkoutToken = utils.getUrlSearch("checkoutToken");
      this.queryStatus = setInterval(() => {
        api.apiMethod.queryOrder
          .post(
            {
              businessCode: this.goodInfo.businessCode,
              merchantPayNo: this.goodInfo.merchantOrderNo,
              merchantCode: this.goodInfo.merchantCode
            },
            {
              checkoutToken: checkoutToken
            }
          )
          .then(res => {
            if (res.data.code === 10000) {
              if (res.data.data.status === 0) {
                // console.log("待付款");
              } else if (res.data.data.status === 1) {
                this.payResult = false;
                this.payStatusResult(1);
                this.backRrturnUrl();
                clearInterval(this.queryStatus);
              } else if (res.data.data.status === 2) {
                this.payResult = false;
                this.payStatusResult(2);
                clearInterval(this.queryStatus);
              } else if (res.data.data.status === 3) {
                this.payResult = false;
                this.payStatusResult(3);
                clearInterval(this.queryStatus);
              }
            } else {
              Notify({ type: "warning", message: res.data.msg });
            }
          });
      }, 2000);
    },
    /**
     * @method selectPay
     * @param {String} payCode 支付方式
     * @description 选择支付方式
     */
    selectPay(payCode) {
      console.log(payCode, "====payCode");
      this.checkoutValue = payCode;

      // 如果选择fpx支付
      if (payCode === 46) {
        this.AdyenCheckoutInit();
      }
      // 如果是airwallex卡支付 - 暂不加载脚本，等点击支付时再加载
      if (payCode === 63) {
        // 只记录选择，不立即加载脚本
      }
      // 如果是ach支付
      if (payCode === 61) {
        // 协议按钮展示
        this.achAgreement = true;
      } else {
        this.achAgreement = false;
      }
      this.reportLog({
        eventId: "PAYMETHOD_PC",
        msg: payCode
      });
    },
    /**
     * @method backRrturnUrl
     * @description 支付状态返回时，跳转到returnUrl
     */
    backRrturnUrl() {
      window.location.href = this.goodInfo.returnUrl;
      // window.location.href = `https://${location.host}/pc?merchantPayNo=${utils.getUrlSearch(
      //   "merchantPayNo"
      // )}&checkoutToken=${utils.getUrlSearch("checkoutToken")}`;
      // this.reportLog({
      //   eventId: "BACKRETURNURL_PC",
      //   msg: `https://${location.host}/pc?merchantPayNo=${utils.getUrlSearch(
      //     "merchantPayNo"
      //   )}&checkoutToken=${utils.getUrlSearch("checkoutToken")}`
      // });
    },
    /**
     * @method failBackRrturnUrl
     * @description 支付失败回到收银台页面
     */
    failBackRrturnUrl() {
      // 刷新当前页面
      window.location.reload();
    },
    // 获取银行卡列表
    async fetchCardList() {
      this.loading = true;
      let checkoutToken = utils.getUrlSearch("checkoutToken");
      let bankAccountListToken = this.bankAccountListToken;
      let merchantPayNo = utils.getUrlSearch("merchantPayNo");
      try {
        api.apiMethod.getCardList
          .post(
            {
              businessCode: this.goodInfo.businessCode,
              merchantPayNo: merchantPayNo
            },
            {
              checkoutToken: checkoutToken,
              bankAccountListToken: bankAccountListToken
            }
          )
          .then(res => {
            console.log(res, "====res");
            if (res.data.code === 10000) {
              this.cardList = res.data.data;
              if (this.cardList.length > 0) {
                this.initialSelectedCardId = this.cardList[0].bankAccountToken;
              }
              this.reportLog({
                eventId: "GETCARD_PC",
                msg: this.checkoutValue
              });
            } else {
              // 设置为新卡支付模式
              this.cardList = [];
              this.reportLog({
                eventId: "GETCARD_ERROR_PC",
                msg: this.checkoutValue
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        console.error("Error fetching card list:", error);
        this.loading = false;
        this.reportLog({
          eventId: "GETCARD_ERROR_PC",
          msg: this.checkoutValue
        });
      }
    },
    /**
     * @method handleAgreement
     * @description 处理协议勾选变化
     */
    handleAgreement(val) {
      // 只有当val有值时(用户实际点击)才记录日志，防止因程序修改isAgree导致的额外事件记录
      if (val !== undefined) {
        this.reportLog({
          eventId: "AGREEMENT_PC",
          msg: this.checkoutValue
        });
      }
    },
    /**
     * @method handleAgreementConfirmed
     * @description 自动勾选协议
     */
    handleAgreementConfirmed() {
      // 自动勾选协议
      this.isAgree = true;

      // 添加日志记录
      this.reportLog({
        eventId: "AGREEMENT_CONFIRMED_PC",
        msg: this.checkoutValue || "ACH"
      });
    },
    /**
     * @method handlePopupClosed
     * @description 弹窗关闭时的处理逻辑，如果用户已同意则设置isAgree为true，否则保持原值
     */
    handlePopupClosed(data) {
      if (data && data.hasAgreed) {
        // 如果之前isAgree是false，现在应该设为true
        if (!this.isAgree) {
          this.isAgree = true;
        }
      } else {
        // 不做任何修改，保持isAgree原值
      }
    },
    /**
     * @method handlePaymentSubmit
     * @description 处理支付提交
     */
    handlePaymentSubmit() {
      // 这里可以添加支付提交前的逻辑
    },
    /**
     * @method handlePaymentChange
     * @description 处理支付表单的完成状态
     */
    handlePaymentChange(state) {
      console.log("PC端接收到Payment data changed:", state);

      // 不要修改isAgree的值，而是单独使用一个变量来跟踪表单状态
      this.isFormValid = state.isValid || false;
      console.log("更新isFormValid为:", this.isFormValid);

      // 处理支付数据
      if (state.data && state.data.paymentMethod) {
        console.log("收到支付方法数据，正在处理");
        try {
          // 深拷贝支付方法数据，避免引用问题
          const paymentMethod = JSON.parse(
            JSON.stringify(state.data.paymentMethod)
          );

          // 删掉不需要的字段
          if (paymentMethod && paymentMethod.checkoutAttemptId) {
            delete paymentMethod.checkoutAttemptId;
          }

          // 保存为JSON字符串
          this.extendParam = JSON.stringify(paymentMethod);
          console.log("处理后的支付数据已准备好:", this.extendParam);
        } catch (error) {
          console.error("处理支付数据时出错:", error);
          this.extendParam = "{}";
        }
      }
    },
    /**
     * @method handlePaymentCompleted
     * @description 处理支付完成
     */
    handlePaymentCompleted(result) {
      console.log("Payment completed:", result);
      // 这里可以添加支付完成后的逻辑，如跳转到成功页面
      const successMsg = this.$t("common.paymentSuccess") || "支付成功";

      // 如果是英文，则分行处理
      if (this.$i18n.locale === "en") {
        // 分割文本成两行
        const words = successMsg.split(" ");
        // 使用换行符分隔单词
        const formattedMsg = `${words[0]}\n${words[1] || ""}`;

        Toast.success({
          message: formattedMsg,
          className: "toast-wrap"
        });
      } else {
        // 非英文直接显示
        Toast.success({
          message: successMsg,
          className: "toast-wrap"
        });
      }

      this.queryOrder();
    },
    /**
     * @method handlePaymentError
     * @description 处理支付错误
     */
    handlePaymentError(error) {
      console.error("Payment error:", error);
      Toast.fail(error.message || "支付处理出错，请稍后再试");
    },
    /**
     * @method closeAchPayment
     * @description 关闭ACH支付
     */
    closeAchPayment() {
      this.showAchPayment = false;
    },
    /**
     * @method cardSelected
     * @description 选择银行卡
     */
    cardSelected(card) {
      console.log(card, "====card");
      this.bankAccountToken = card.bankAccountToken;
      this.reportLog({
        eventId: "SELECTCARD_PC",
        msg: this.checkoutValue
      });
    },
    /**
     * @method deleteCard
     * @description 删除银行卡
     */
    deleteCard(card) {
      console.log(card, "====deleteCard");
      // 重新获取银行卡列表
      this.fetchCardList();
    },

    /**
     * @method handleAirwallexSuccess
     * @description 处理Airwallex支付成功
     */
    handleAirwallexSuccess(result) {
      console.log("Airwallex payment success:", result);
      // 查询订单状态
      this.queryOrder();
    },

    /**
     * @method handleAirwallexError
     * @description 处理Airwallex支付错误
     */
    handleAirwallexError(error) {
      console.error("Airwallex payment error:", error);
      // 可以添加错误处理逻辑
      // 失败
      this.payStatusResult(2);
      this.reportLog({
        eventId: "PAYERROR_PC",
        msg: this.checkoutValue
      });
    },

    /**
     * @method handleAirwallexInitialized
     * @description 处理Airwallex初始化完成
     */
    handleAirwallexInitialized() {
      console.log("Airwallex initialized successfully");
      this.loading = false;
    }
  },
  mounted() {
    this.payWayConfigList();
    this.setGoodInfo();
    console.log(this.$i18n.locale, "this.$i18n.locale");
    if (this.$i18n.locale === "en") {
      this.languageTitle = "English";
      this.$i18n.locale = "en";
      this.languagekey = "0";
    } else if (this.$i18n.locale === "zh") {
      this.languageTitle = "简体中文";
      this.$i18n.locale = "zh";
      this.languagekey = "1";
    } else if (this.$i18n.locale === "fr") {
      this.languageTitle = "Français";
      this.$i18n.locale = "fr";
      this.languagekey = "2";
    } else if (this.$i18n.locale === "ja") {
      this.languageTitle = "日本語";
      this.$i18n.locale = "ja";
      this.languagekey = "3";
    } else if (this.$i18n.locale === "ko") {
      this.languageTitle = "한국어";
      this.$i18n.locale = "ko";
      this.languagekey = "4";
    }
    // this.loadAirwallexScript();
    this.reportLog({
      eventId: "OPENCHECKOUT_PC",
      msg: ""
    });
  }
};
</script>
<style lang="less">
.pcBox {
  width: 100%;
  height: 100%;
  .pcBox-header {
    width: 100%;
    height: 100px;
    background-color: #fff;
    border-bottom: 4px solid #ffaa0a;
    & > div {
      width: 1180px;
      height: 48px;
      padding: 26px 0;
      margin: 0 auto;
      span {
        vertical-align: middle;
        font-size: 20px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
      }
      .logo {
        width: 48px;
        height: 48px;
        display: inline-block;
        background: url("../../assets/pc/logo_Cashier@2x.png") no-repeat;
        background-size: 48px;
      }
      .div_select_right {
        float: right;
        margin-top: 5px;
        display: flex;
        align-items: center;
        .div_close_button {
          margin-left: 10px;
          width: 38px;
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-radius: 10px;
          background: rgba(252, 252, 252, 0.2);
          border: 1px solid rgba(121, 119, 119, 0.2);
          transition: all 0.2s;

          &:hover {
            background: rgba(255, 255, 255, 0.5);
          }

          .close-icon {
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .el-select {
          width: 160px !important;
          .el-input {
            border-radius: 8px;
            .el-input__inner {
              border-radius: 8px;
              // border: 1px solid #ffaa0a;
            }
          }
          .is-focus .el-input__inner,
          .el-input.is-active .el-input__inner,
          .el-input__inner:focus,
          .el-input__inner:hover {
            border-color: #dcdfe6;
            // box-shadow: 0 0 0 2px rgba(255, 170, 10, 0.2);
          }
        }
      }
      .div_right {
        height: 30px;
        line-height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 16px;
        margin-top: 8px;
        padding: 0px 12px;
        cursor: pointer;
        span {
          color: rgba(102, 102, 102, 1) !important;
          font-size: 14px !important;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
        }
        .lgIcon {
          width: 16px;
          height: 16px;
          display: inline-block;
          background: url("../../assets/pc/switch_pc.svg") no-repeat;
          background-size: 100%;
        }
      }
      .div_right:hover {
        background: rgba(240, 240, 240, 1);
      }
    }
  }
  .pcBox-center {
    width: 1100px;
    margin: 24px auto;
    background-color: #fff;
    padding: 40px;
    border-radius: 8px;
    .topStatus {
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(226, 226, 226, 1);
      .top {
        span {
          display: inline-block;
          vertical-align: middle;
        }
        .statusIcon {
          width: 24px;
          height: 24px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .statusText {
          font-size: 24px;
          line-height: 24px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          margin-left: 12px;
        }
        .div_right {
          line-height: 24px;
        }
      }
      .timeBox {
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding-left: 36px;
        margin-top: 16px;
        span {
          font-weight: 600;
          color: rgba(255, 121, 40, 1);
        }
      }
    }
    .botGoods {
      padding-top: 24px;
      .part {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 16px;
        .leftTitle {
          display: inline-block;
          line-height: 24px;
          margin-right: 24px;
          color: rgba(102, 102, 102, 1);
        }
        .rightInfo {
          color: rgba(51, 51, 51, 1);
          word-wrap: break-word;
          word-break: break-all;
          line-height: 24px;
        }
      }
    }
  }
  .pcBox-footer {
    padding: 40px;
    background: #fff;
    width: 1100px;
    margin: 0 auto;
    border-radius: 8px;
    margin-bottom: 100px;
    .title {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      margin-bottom: 24px;
    }
    .payWays {
      .part {
        // display: flex;
        width: 370px;
        // min-height: 46px;
        padding: 16px 20px;
        border-radius: 8px;
        margin-bottom: 16px;
        border: 1px solid rgba(204, 204, 204, 1);
        cursor: pointer;
        span {
          display: inline-block;
          vertical-align: middle;
        }
        .payIcon {
          height: 48px;
          img {
            height: 100%;
          }
        }
        .payPro {
          min-height: 48px;
          line-height: 48px;
          color: rgba(51, 51, 51, 1);
          margin-left: 16px;
          .van-cell {
            padding: 0 !important;
            min-height: 48px;
            font-size: 16px;
            font-weight: 400;
            background-color: rgba(0, 0, 0, 0);
          }
        }
        .tip {
          color: #969799;
          font-size: 12px;
          line-height: 18px;
        }
      }
      .hoverPart:hover {
        border: 1px solid #ffaa0a !important;
      }
    }
    .payBtn {
      width: 220px;
      height: 40px;
      background: #ffaa0a;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      // margin-top: 40px;
    }
    .payBtn:hover {
      background: #ec9d0a;
    }
    .paybtn-wrap {
      position: absolute;
    }
    .resultIcon {
      width: 140px;
      height: 140px;
      margin: 20px auto 16px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .resultText {
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      text-align: center;
      margin-bottom: 20px;
      span {
        color: #1082ff;
        cursor: pointer;
      }
    }
  }
  .loadingBox {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    .bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 1);
      opacity: 0.5;
    }
    .centerBox {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 144px;
      height: 106px;
      padding: 20px 0;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      img {
        display: block;
        width: 80px;
        height: 80px;
        margin: 0 auto;
      }
      & > div {
        text-align: center;
        margin-top: 12px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
      }
    }
  }
  .payResultBox {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    .bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 1);
      opacity: 0.5;
    }
    .payResultCenterBox {
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      .title {
        height: 24px;
        padding: 10px 12px 10px 14px;
        background: rgba(248, 248, 248, 1);
        border-radius: 8px 8px 0px 0px;
        .div_left {
          font-size: 16px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 24px;
          vertical-align: middle;
          img {
            display: inline-block;
            width: 24px;
            height: 24px;
            vertical-align: middle;
            margin-right: 8px;
            margin-top: -3px;
          }
        }
        .div_right {
          span {
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin-top: 2px;
            cursor: pointer;
            background: url("../../assets/pc/fork_popup.svg") no-repeat;
            background-size: 100%;
          }
          span:hover {
            background: url("../../assets/pc/fork_popup_hower.svg") no-repeat;
            background-size: 100%;
          }
        }
      }
      .centerContent {
        padding: 32px 45px;
        .qrcode {
          width: 200px;
          height: 200px;
          display: block;
          margin: 0 auto;
        }
        .botText {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-top: 8px;
          span {
            font-weight: 600;
            color: rgba(255, 121, 40, 1);
          }
        }
      }
    }
  }
}
.ali-hk-frame {
  padding-left: 44px;
}
.mol_tip {
  margin-bottom: 10px;
}
#molpay_ebanking_fpx_MY-container {
  width: 412px;
  margin-bottom: 16px;
  cursor: pointer;
  .adyen-checkout__dropdown__button {
    padding-left: 22px !important;
    border-color: rgb(204, 204, 204);
    border-color: rgb(255, 170, 10);
    box-sizing: border-box;
  }
  .Select-module_adyen-checkout__dropdown__button__yTyqq:after {
    right: 10px !important;
  }
  .adyen-checkout__dropdown__element__icon {
    max-height: 20px;
  }
  .adyen-checkout__dropdown__element__text {
    font-size: 14px;
    font-weight: bold;
  }
  input {
    cursor: pointer;
  }
}

.googleOrApplePayButton {
  width: 260px;
  height: 40px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  margin: 32px auto 0;
}
.googleOrApplePayButton-wrap, .stripeExpressCheckoutButton-wrap {
  flex-wrap: wrap;
  padding-top: 40px;
  text-align: center;
  .tips {
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }
}
.loading-img {
  width: 30px;
  height: 30px;
  margin: 32px auto 0;
  -webkit-transform: rotate(360deg);
  animation: rotation 2s linear infinite;
  -moz-animation: rotation 2s linear infinite;
  -webkit-animation: rotation 2s linear infinite;
  -o-animation: rotation 2s linear infinite;
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
.payBtn-group {
  margin-top: 40px;
}
.agreement-group {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  // 协议文本样式
  font-size: 14px;
  color: #666;

  .agreement-text {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin-left: 10px;
  }
}
.van-checkbox__icon--checked .van-icon {
  border-radius: 50%;
  background-color: #ffaa0a;
  border-color: #ffaa0a;
}
.van-checkbox__icon .van-icon {
  border-radius: 50%;
}

.stripeExpressCheckoutButton {
  padding: 20px;
}
</style>
